module.exports = {
      id: "multiLogo-usage",
      viewBox: "0 0 130 32",
      url: __webpack_public_path__ + "sprite.b16108e5f95a8323b5a812454e446fa5.svg#multiLogo-usage",
      toString: function () {
        return this.url;
      }
    }